// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'iview/dist/styles/iview.css';
import iView from 'iview';
import HappyScroll from 'vue-happy-scroll';
import 'vue-happy-scroll/docs/happy-scroll.css';
import Vue from 'vue';
import Config from '@/utils/Config';
import settings from '@/utils/settings';
import VueNativeSock from 'vue-native-websocket';
import VueI18n from 'vue-i18n';
import globlI18n from '@/i18n';
import VueTelInput from 'vue-tel-input';
import vSelect from 'vue-select';
import App from './App';
import router from './router';
import store from './store';


Vue.component('v-select', vSelect);
Vue.use(VueI18n);
Vue.use(VueTelInput);

const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || Config.defaultLanguage || 'en',
    messages: globlI18n,
});
Vue.use(VueNativeSock, settings.webSocketAddress, {
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 3000,
    format: 'json',
    store,
});

Vue.use(iView);
Vue.use(HappyScroll);
require('@/utils/filters');

Vue.config.productionTip = false;


/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: { App },
    template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js